import _ from 'lodash'
import {
  ChartToolTip,
  Title,
  Item,
  ItemIcon
} from '../../../Common/NewDashboard/Chart/ToolTip'
import { getDashboardDateTime } from '../../../../lib/MomentHelper'
import { dollarFormat, numeralFormat } from '../../../../../lib/renderUtil'

const SellerDailyChartTooltip = props => {
  const { active, payload, label: reportDate, format } = props

  const {
    amount,
    quantity,
    soldQuantity,
    pageView,
    totalViewerQuantity,
    buyerQuantity,
    uniqueCartQuantity,
    totalAddCartUserQuantity
  } = _.get(payload, '[0].payload', {})
  const numberAmountValue = _.toNumber(amount)
  const numberQuantityValue = _.toNumber(quantity)
  const numberSoldQuantityValue = _.toNumber(soldQuantity)
  const numberPageViewValue = _.toNumber(pageView)
  const numberTotalViewerQuantityValue = _.toNumber(totalViewerQuantity)
  const numberBuyerQuantityValue = _.toNumber(buyerQuantity)
  const numberUniqueCartQuantityValue = _.toNumber(uniqueCartQuantity)
  const numberTotalAddCartUserQuantityValue = _.toNumber(totalAddCartUserQuantity)

  if (active) {
    return (
      <ChartToolTip>
        <Title>
          {getDashboardDateTime(reportDate, format)}
        </Title>
        <Item>
          <ItemIcon color='#6a96f3' />
          {`訂單成立金額：${dollarFormat(numberAmountValue)}`}
        </Item>
        <Item>
          <ItemIcon color='#7dd5a9' />
          {`訂單成立數量：${numeralFormat(numberQuantityValue, { allowZero: true })}`}
        </Item>
        <Item>
          {`平均客單：${numeralFormat(numberAmountValue / numberQuantityValue, { allowZero: true })}`}
        </Item>
        <Item>
          {`瀏覽量：${numeralFormat(numberPageViewValue, { allowZero: true })}`}
        </Item>
        <Item>
          {`轉換率：${numeralFormat((numberSoldQuantityValue / numberPageViewValue) * 100, { allowZero: true })}%`}
        </Item>
        <Item>
          {`加入購物車次數：${numeralFormat(numberTotalAddCartUserQuantityValue, { allowZero: true })}`}
        </Item>
        <Item>
          {`訂購量：${numeralFormat(numberSoldQuantityValue, { allowZero: true })}`}
        </Item>
        <Item>
          {`不重複買家數：${numeralFormat(numberBuyerQuantityValue, { allowZero: true })}`}
        </Item>
        <Item>
          {`不重複購物車數：${numeralFormat(numberUniqueCartQuantityValue, { allowZero: true })}`}
        </Item>
        <Item>
          {`不重複訪客數：${numeralFormat(numberTotalViewerQuantityValue, { allowZero: true })}`}
        </Item>
      </ChartToolTip>
    )
  }
  return null
}

export default SellerDailyChartTooltip
